export default function Testimonios() {
  const testimonios = [
    {
      nombre: 'Sarah Mitchell',
      profesion: 'Product Designer',
      ciudad: 'San Francisco → Barcelona',
      testimonio: 'De San Francisco a Barcelona: mejor decisión de mi vida. El proceso fue claro y profesional. Ahorro $2,000 al mes y vivo en una ciudad increíble.',
      imagen: 'https://public.readdy.ai/ai/img_res/4e07737c52de65c7d6b639650592ea72.jpg',
      ahorro: 'Ahorro $2,000/mes'
    },
    {
      nombre: 'Marcus Johnson',
      profesion: 'Software Engineer',
      ciudad: 'Austin → Madrid',
      testimonio: 'Proceso claro, sin sorpresas, todo como prometieron. La asesoría fue excelente desde el primer día. Ahora disfruto de Madrid mientras trabajo para clientes en USA.',
      imagen: 'https://readdy.ai/api/search-image?query=Professional%20African%20American%20male%20software%20engineer%20in%20his%2030s%20smiling%20in%20modern%20Madrid%20office%2C%20natural%20lighting%2C%20professional%20headshot%20photography%2C%20tech%20professional%2C%20confident%20and%20happy%20expression&width=400&height=400&seq=test-marcus-002&orientation=squarish',
      ahorro: 'Proceso impecable'
    },
    {
      nombre: 'Amanda Torres',
      profesion: 'Marketing Consultant',
      ciudad: 'NYC → Valencia',
      testimonio: 'La asesoría fiscal del paquete Premium valió cada euro. Ahorro $15k al año con Beckham Law. El equipo de Lino García es excepcional.',
      imagen: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20woman%20marketing%20consultant%20in%20her%2030s%20smiling%20in%20beautiful%20Valencia%20coworking%20space%2C%20natural%20lighting%2C%20professional%20headshot%20photography%2C%20Mediterranean%20background%2C%20successful%20and%20happy&width=400&height=400&seq=test-amanda-003&orientation=squarish',
      ahorro: 'Ahorro $15k/año'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl lg:text-5xl font-bold text-center mb-4 text-gray-900">
            Testimonios Reales
          </h2>
          <p className="text-xl text-center text-gray-600 mb-16">
            Más de 150 nómadas ya viven en España gracias a nuestro servicio
          </p>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {testimonios.map((test, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all hover:-translate-y-1"
              >
                <div className="flex items-center gap-4 mb-6">
                  <img 
                    src={test.imagen}
                    alt={test.nombre}
                    className="w-20 h-20 rounded-full object-cover object-top"
                  />
                  <div>
                    <h4 className="font-bold text-lg text-gray-900">{test.nombre}</h4>
                    <p className="text-sm text-gray-600">{test.profesion}</p>
                    <p className="text-xs text-blue-600 font-semibold">{test.ciudad}</p>
                  </div>
                </div>
                <div className="mb-4">
                  <div className="flex gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                    ))}
                  </div>
                  <p className="text-gray-700 leading-relaxed italic">
                    &ldquo;{test.testimonio}&rdquo;
                  </p>
                </div>
                <div className="bg-green-50 border border-green-200 rounded-lg px-4 py-2 inline-block">
                  <p className="text-green-700 font-semibold text-sm">{test.ahorro}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl shadow-xl p-8 text-center text-white">
            <div className="flex flex-wrap justify-center items-center gap-8">
              <div>
                <p className="text-5xl font-bold mb-2">+150</p>
                <p className="text-blue-100">Nómadas en España</p>
              </div>
              <div className="hidden md:block w-px h-16 bg-blue-400"></div>
              <div>
                <p className="text-5xl font-bold mb-2">4.9/5</p>
                <p className="text-blue-100">Google Reviews</p>
              </div>
              <div className="hidden md:block w-px h-16 bg-blue-400"></div>
              <div>
                <p className="text-5xl font-bold mb-2">100%</p>
                <p className="text-blue-100">Tasa de Aprobación</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
